import { createIframe } from '../dom'

let map = {}
let hash

const TIMEOUT_ERROR = {
  errno: 100,
  error: 'Co 模块请求超时'
}

export default {
  init(domain, disableHash) {
    if (disableHash) {
      hash = 0
    } else {
      hash = parseInt(Math.random() * 10)
    }

    map[`${domain + '-' + hash}`] = {
      frame: null,
      frameLoaded: false,
      callbackMap: {},
      messages: []
    }

    window.addEventListener('message', event => {
      let origin = event.origin || event.originalEvent.origin
      if (origin === domain) {
        let data = event.data
        let callbacks = map[`${domain + '-' + hash}`].callbackMap[data.call] || []
        let len = callbacks.length

        while (len--) {
          let callback = callbacks[len]
          if (callback[0].isTimeout) {
            continue
          }
          clearTimeout(callback[1])

          callback[0](data.response)
          callbacks.splice(len, 1)
        }
      }
    })

    return map[`${domain + '-' + hash}`]
  },
  send({ domain, url, call, param, callback, fallback, timeout = 5000 }) {
    let msg = {
      param: param,
      call: call
    }

    let nameSpace = map[`${domain + '-' + hash}`]

    if (!nameSpace.frameLoaded) {
      if (!nameSpace.frame) {
        nameSpace.frame = createIframe(url, '', () => {
          nameSpace.frameLoaded = true

          nameSpace.messages.forEach(msg => {
            nameSpace.frame.contentWindow.postMessage(msg, domain)
          })
        })
      }
      nameSpace.messages.push(msg)
    } else {
      nameSpace.frame.contentWindow.postMessage(msg, domain)
    }

    let timer = setTimeout(() => {
      if (timeout) {
        if (callback) {
          callback.isTimeout = true
        }
        fallback && fallback(TIMEOUT_ERROR)
      }
    }, timeout)

    if (!nameSpace.callbackMap[call]) {
      nameSpace.callbackMap[call] = []
    }

    if (callback) {
      nameSpace.callbackMap[call].push([callback, timer])
    }
  }
}